import PatientDevices from './PatientDevices';

export default PatientDevices;
